import React, {memo} from 'react';
import type { FC } from 'react';
import { Backdrop, Paper } from '@material-ui/core';
import { useAcceptCookies } from './AcceptCookies.state';
import { useStyles } from './AcceptCookies.styles';
import { TextBlock } from './TextBlock';
import { Buttons } from './Buttons';
import { Settings } from './Settings';

export const AcceptCookies: FC = memo(() => {
  const { onAcceptAllHandler, isConfirmationHidden, ...settingsState} = useAcceptCookies();
  const { isCookiesSettingsOpen, onCloseCookiesSettinsHandler, onOpenCookiesSettinsHandler } = settingsState;

  const classes = useStyles();

  return <Backdrop className={classes.backdrop} open={!isConfirmationHidden}> 
      <Paper className={classes.paper}>
        <TextBlock />
        <Buttons onAcceptAll={onAcceptAllHandler} onOpenSettings={onOpenCookiesSettinsHandler} />
        <Settings open={isCookiesSettingsOpen} onClose={onCloseCookiesSettinsHandler} onConfirmCookies={onAcceptAllHandler}/>
      </Paper> 
  </Backdrop>;
});
